import * as actions from "./actions";

let initialState = {
  shortTermInvoices: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  invoices: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },
};

const invoices = (state = initialState, action) => {
  switch (action.type) {
    // GET INVOICES
    case actions.USER_INVOICES_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        invoices: Object.assign({}, state.invoices, {
          fetching: true,
          error: null,
          data: null,
        }),
      });
    case actions.USER_INVOICES_LIST_GET_SUCCESS:
      return Object.assign({}, state, {
        invoices: Object.assign({}, state.invoices, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.USER_INVOICES_LIST_GET_ERROR:
      return Object.assign({}, state, {
        invoices: Object.assign({}, state.invoices, {
          fetching: false,
          error: action.error,
        }),
      });
    case actions.USER_INVOICE_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        invoices: Object.assign({}, state.invoices, {
          table: Object.assign({}, state.invoices.table, {
            pagination: Object.assign({}, state.invoices.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });
    case actions.USER_INVOICE_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        invoices: Object.assign({}, state.invoices, {
          table: Object.assign({}, state.invoices.table, {
            currentFilter: Object.assign(
              {},
              state.invoices.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    // GET SHORT TERM INVOICES
    case actions.USER_ST_INVOICES_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        shortTermInvoices: Object.assign({}, state.shortTermInvoices, {
          fetching: true,
          error: null,
          data: null,
        }),
      });
    case actions.USER_ST_INVOICES_LIST_GET_SUCCESS:
      return Object.assign({}, state, {
        shortTermInvoices: Object.assign({}, state.shortTermInvoices, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.USER_ST_INVOICES_LIST_GET_ERROR:
      return Object.assign({}, state, {
        shortTermInvoices: Object.assign({}, state.shortTermInvoices, {
          fetching: false,
          error: action.error,
        }),
      });
    default:
      return state;
  }
};

export default invoices;
